export type InventoryNavItem = { resource: string; label: string };

export type InventoryNavSection = {
    sectionLabel: string;
    items: InventoryNavItem[];
};

export const INVENTORY_TRANSACTIONS_NAV_SECTIONS: InventoryNavSection[] = [
    {
        sectionLabel: 'Transactions',
        items: [
            { resource: 'stockTransactions', label: 'Stock Transactions' },
            { resource: 'stockIssuance', label: 'Stock Issuance' },
            { resource: 'stockReturn', label: 'Stock Return' },
            { resource: 'goodsReceipt', label: 'Goods Receipt' },
            { resource: 'gateOutward', label: 'Gate Outward' },
            { resource: 'jobCardIssuance', label: 'Job Card Issuance' },
        ],
    },
];

export const INVENTORY_REPORTS_NAV: InventoryNavItem[] = [
    { resource: 'itemStockReport', label: 'Item Stock' },
];

export const INVENTORY_CONFIGURATION_NAV: InventoryNavItem[] = [
    { resource: 'inventWarehouses', label: 'Warehouses' },
    { resource: 'productProfiles', label: 'Product Profiles' },
    { resource: 'productCategories', label: 'Product Categories' },
];

export const INVENTORY_MAINTENANCE_NAV: InventoryNavItem[] = [
    { resource: 'stockPatch', label: 'Stock Patch' },
];

export const INVENTORY_ALL_NAV: InventoryNavItem[] = [
    ...INVENTORY_TRANSACTIONS_NAV_SECTIONS.flatMap(s => s.items),
    ...INVENTORY_REPORTS_NAV,
    ...INVENTORY_CONFIGURATION_NAV,
    ...INVENTORY_MAINTENANCE_NAV,
];
